import { render } from "./AccordSVG.vue?vue&type=template&id=41d53484"
import script from "./AccordSVG.vue?vue&type=script&lang=js"
export * from "./AccordSVG.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__